module.exports = __webpack_public_path__ + "img/case-bj5.f37b2959.png";